/**
 * @file machine_app_empty_item_page.js
 * @author MachineApps Team
 *
 * @description Creates a view for the machine app item where no instance of that item has been.
 * instanciated yet.
 */

import $ from 'jQuery';
import { gMachineAppViews } from '../machine_app_global_variables';
import { machineAppItemEditor } from '../machine_app_item_editor';

/**
 * Gets the empty view page for items that do not have any defined data yet
 * @param {Function} onUpdate
 * @param {Function} createNewItem
 * @param {Function} listItems
 * @param {Object} flavorText
 * @param {import('./machine_app_view').MachineAppViewString} view
 * @param {String} [assetType]
 * @returns {{body: JQuery, header: JQuery}}
 */
export function getEmptyView(onUpdate, createNewItem, listItems, flavorText, view, assetType = undefined){
  const lHeader = $('<h2>').text(flavorText.pluralName);
  const lContainer = $('<div>').addClass('machine_parameters_empty_page');
  const lDescription = ($('<label>').html(flavorText.description)).addClass('machine_parameters_empty_page_subtitle');
  const pOnClick = function() {
    const newItemName = view === gMachineAppViews.machineParameters ? flavorText.defaultName : flavorText.defaultName + ' #' + (listItems().length + 1);
    const newItem = createNewItem(newItemName, assetType);
    machineAppItemEditor(newItem, onUpdate);
  };
  const lButton = $('<button>').addClass('machine_parameters_empty_page_create_button').append(
    $('<i>').addClass('far fa-plus'),
    $('<span>').text(flavorText.createButton)
  ).on('click', pOnClick);


  lContainer.append(
    lDescription,
    lButton
  );

  return {
    body: lContainer,
    header: lHeader
  };
}